import { FC, useState } from "react";
import {
  InputText,
} from "../../../../components/input";

import {
  IInputArrayFormProps,
  IInputArrayDataStructureItem,
} from "../../../../components/input/arrayData";
import { CreateNotification } from "../../../../components/notifier";
import {
  getDDMMYYYFormat,
} from "../../../../helper/dateTimeHelper";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { ObjectUtils } from "../../../../modules/utils";
import { UploadFile } from "../../uploadFile";
import { InputDateRangePicker } from "../../../../components/input/date-range-picker";
import { Upload } from "../../upload";
import { InputGroupSelect } from "../../../../components/input/select/select-group";
import { getDefaultEstimatedTimeOfUse } from "../../util";
// structure dài hạn cấp mới
export const LongTermNewExternalBusinessVehicleCardFormStructure: IInputArrayDataStructureItem[] =
  [
    {
      name: "unit",
      label: "Đơn vị",
      isVisibleOnList: true,
    },
    {
      name: "nameVehical",
      label: "Tên phương tiện",
      isVisibleOnList: true,
    },
    {
      name: "licensePlate",
      label: "Biển kiểm soát",
      isVisibleOnList: true,
    },
    {
      name: "vehicleRegistrationCertificateId",
      label: "Số giấy đăng ký phương tiện/Giấy phép khai thác thiết bị hàng không",
      isVisibleOnList: true,
    },
    {
      name: "vehicleRegistrationCertificate",
      label: "Giấy đăng ký phương tiện/Giấy phép khai thác thiết bị hàng không",
      isVisibleOnList: true,
    },
    {
      name: "certificateOfInspectionId",
      label:
        "Số chứng nhận kiểm định ATKT và BVMT giao thông/Biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
      isVisibleOnList: true,
    },
    {
      name: "certificateOfInspection",
      label:
        "Sổ chứng nhận kiểm định ATKT và BVMT giao thông/Biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
      isVisibleOnList: true,
    },
    {
      name: "driveLicense",
      label: "Giấy phép lái xe",
      isVisibleOnList: true,
    },
    {
      name: "grantPeriod",
      label: "Thời hạn cấp",
      isVisibleOnList: true,
    },
    {
      name: "grantedArea",
      label: "Khu vực đề nghị",
      isVisibleOnList: true,
    },
    {
      name: "gateAway",
      label: "Cổng vào",
      isVisibleOnList: true,
    },
    {
      name: "exit",
      label: "Cổng ra",
      isVisibleOnList: true,
    },
    {
      name: "photoContract",
      label: "Bản photo hợp đồng",
      isVisibleOnList: true,
    },
    
  ];
// structure dài hạn gia hạn
export const LongTermExtendExternalBusinessVehicleCardFormStructure: IInputArrayDataStructureItem[] =
  [
    {
      name: "unit",
      label: "Đơn vị",
      isVisibleOnList: true,
    },
    {
      name: "nameVehical",
      label: "Tên phương tiện",
      isVisibleOnList: true,
    },
    {
      name: "licensePlate",
      label: "Biển kiểm soát",
      isVisibleOnList: true,
    },
    {
      name: "vehicleRegistrationCertificate",
      label: "Giấy đăng ký phương tiện/Giấy phép khai thác thiết bị hàng không",
      isVisibleOnList: true,
    },
    {
      name: "vehicleRegistrationCertificateId",
      label: "Số giấy đăng ký phương tiện/Giấy phép khai thác thiết bị hàng không",
      isVisibleOnList: true,
    },
    {
      name: "certificateOfInspection",
      label:
        "Sổ chứng nhận kiểm định ATKT và BVMT giao thông/Biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
      isVisibleOnList: true,
    },
    {
      name: "certificateOfInspectionId",
      label:
        "Số chứng nhận kiểm định ATKT và BVMT giao thông/Biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
      isVisibleOnList: true,
    },
    {
      name: "driveLicense",
      label: "Giấy phép lái xe",
      isVisibleOnList: true,
    },
    {
      name: "grantPeriod",
      label: "Thời hạn cấp",
      isVisibleOnList: true,
    },
    {
      name: "grantedArea",
      label: "Khu vực đề nghị",
      isVisibleOnList: true,
    },
    {
      name: "gateAway",
      label: "Cổng vào",
      isVisibleOnList: true,
    },
    {
      name: "exit",
      label: "Cổng ra",
      isVisibleOnList: true,
    },
    {
      name: "photoContract",
      label: "Bản photo hợp đồng",
      isVisibleOnList: true,
    },
    {
      name: "NumberOfVehicleLicensesIssued",
      label: "Số giấy phép phương tiện đã cấp",
      isVisibleOnList: true,
    },
    {
      name: "OldKSANCardPhoto",
      label: "Bản photo giấy phép phương tiện đã cấp",
      isVisibleOnList: true,
    },
  ];
// structure dài hạn cấp lại
export const LongTermRenewExternalBusinessVehicleCardFormStructure: IInputArrayDataStructureItem[] =
  [
    {
      name: "nameVehical",
      label: "Tên phương tiện",
      isVisibleOnList: true,
    },
    {
      name: "licensePlate",
      label: "Biển kiểm soát",
      isVisibleOnList: true,
    },
    {
      name: "vehicleRegistrationCertificate",
      label: "Giấy đăng ký phương tiện/Giấy phép khai thác thiết bị hàng không",
      isVisibleOnList: true,
    },
    {
      name: "vehicleRegistrationCertificateId",
      label: "Số giấy đăng ký phương tiện/Giấy phép khai thác thiết bị hàng không",
      isVisibleOnList: true,
    },
    {
      name: "certificateOfInspection",
      label:
        "Sổ chứng nhận kiểm định ATKT và BVMT giao thông/Biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
      isVisibleOnList: true,
    },
    {
      name: "certificateOfInspectionId",
      label:
        "Số chứng nhận kiểm định ATKT và BVMT giao thông/Biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
      isVisibleOnList: true,
    },
    {
      name: "driveLicense",
      label: "Giấy phép lái xe",
      isVisibleOnList: true,
    },
    {
      name: "grantPeriod",
      label: "Thời hạn cấp",
      isVisibleOnList: true,
    },
    {
      name: "grantedArea",
      label: "Khu vực đề nghị",
      isVisibleOnList: true,
    },
    {
      name: "gateAway",
      label: "Cổng vào",
      isVisibleOnList: true,
    },
    {
      name: "exit",
      label: "Cổng ra",
      isVisibleOnList: true,
    },
    {
      name: "unit",
      label: "Đơn vị",
      isVisibleOnList: true,
    },
    {
      name: "NumberOfVehicleLicensesIssued",
      label: "Số giấy phép phương tiện đã cấp",
      isVisibleOnList: true,
    },
    {
      name: "photoContract",
      label: "Bản photo hợp đồng",
      isVisibleOnList: true,
    },
    {
      name: "OldKSANCardPhoto",
      label: "Bản photo giấy phép phương tiện đã cấp",
      isVisibleOnList: true,
    },
    {
      name: "ExcuseLose",
      label: "Đơn cớ mất",
      isVisibleOnList: true,
    },
  ];
// form dài hạn cấp mới
export const LongTermNewExternalBusinessVehicleCardContentForm: FC<
  IInputArrayFormProps
> = (props: any) => {
  const { childFormData } = props;
  const today = new Date();
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(getDefaultEstimatedTimeOfUse(childFormData?.grantPeriod));

  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item: any) => {
      return {
        ...item,
        defaultValue:
          ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      // values.unit = selectedTeam ? selectedTeam.value : values.unit;
      values.grantPeriod = estimatedTimeOfUse ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1]) : values.grantPeriod;
      values.vehicleRegistrationCertificate = values.vehicleRegistrationCertificate.length > 0 ? JSON.stringify(values.vehicleRegistrationCertificate) : "";
      values.certificateOfInspection = values.certificateOfInspection.length > 0 ? JSON.stringify(values.certificateOfInspection) : "";
      // values.photoContract = values.photoContract.length > 0 && JSON.stringify(values.photoContract);
      
      // values.grantedArea = values.grantedArea.length > 0 && JSON.stringify(values.grantedArea);

      if (
        !values.nameVehical ||
        !values.licensePlate ||
        // !values.vehicleRegistrationCertificate ||
        !values.vehicleRegistrationCertificateId ||
        // !values.certificateOfInspection ||
        !values.grantPeriod ||
        !values.grantedArea ||
        !values.gateAway ||
        !values.exit ||
        !values.unit 
      )
        {CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }
      else props.onSubmit(values);
    },
  });

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc
        phải nhập{" "}
      </h6>
      <InputWraper
        inputProps={getInputProps("unit")}
        renderInput={(s) => (
          <InputText {...s}/> )}
        //   <InputSelect
        //     {...s}
        //     options={props.teamList.map((o: any) => ({
        //       id: o.id,
        //       label: o.value,
        //       value: o.value,
        //     }))}
        //     value={selectedTeam?.value}
        //     onChange={onTeamChange}
        //     placeholder="* Chọn đội/tổ"
        //   />
        // )}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("nameVehical")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("licensePlate")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("vehicleRegistrationCertificate")}
        renderInput={(s) => <Upload {...s} />}
        // isRequired
      />

      <InputWraper
        inputProps={getInputProps("vehicleRegistrationCertificateId")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("certificateOfInspection")}
        renderInput={(s) => <Upload {...s} />}
        // isRequired
      />

      <InputWraper
        inputProps={getInputProps("certificateOfInspectionId")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("driveLicense")}
        renderInput={(s) => <UploadFile {...s} />}
      />

      <InputWraper
        inputProps={getInputProps("grantPeriod")}
        renderInput={(s) => (
          <InputDateRangePicker
            {...s}
            value={estimatedTimeOfUse}
            onChange={setEstimatedTimeOfUse}
            minDate={today}
          />
        )}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantedArea")}
        renderInput={(s) => <InputGroupSelect {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("gateAway")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("exit")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />
       <InputWraper
        inputProps={getInputProps("photoContract")}
        renderInput={(s) => <UploadFile {...s} />}
      />
        {/* <InputWraper
        inputProps={getInputProps("NumberOfVehicleLicensesIssued")}
        renderInput={(s) => <InputText {...s} />}
      /> */}

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
// form dài hạn gia hạn
export const LongTermExtendExternalBusinessVehicleCardContentForm: FC<
  IInputArrayFormProps
> = (props: any) => {
  const { childFormData } = props;
  const today = new Date();
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(getDefaultEstimatedTimeOfUse(childFormData?.grantPeriod));

  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item: any) => {
      return {
        ...item,
        defaultValue:
          ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      // values.unit = selectedTeam ? selectedTeam.value : values.unit;
      values.grantPeriod = estimatedTimeOfUse ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1]) : values.grantPeriod;
      values.vehicleRegistrationCertificate = values.vehicleRegistrationCertificate.length > 0 ? JSON.stringify(values.vehicleRegistrationCertificate) : "";
      values.certificateOfInspection = values.certificateOfInspection.length > 0 ? JSON.stringify(values.certificateOfInspection) : "";
      // values.photoContract = values.photoContract.length > 0 && JSON.stringify(values.photoContract);

      // values.grantedArea = values.grantedArea.length > 0 && JSON.stringify(values.grantedArea);

      if (
        !values.nameVehical ||
        !values.licensePlate ||
        // !values.vehicleRegistrationCertificate ||
        !values.vehicleRegistrationCertificateId ||
        // !values.certificateOfInspection ||
        !values.grantedArea ||
        !values.gateAway ||
        !values.exit ||
        !values.unit ||
        !values.grantPeriod ||
        !values.NumberOfVehicleLicensesIssued 
        // !values.OldKSANCardPhoto
        
      )
        {CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }
      else props.onSubmit(values);
    },
  });

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc
        phải nhập{" "}
      </h6>
      <InputWraper
        inputProps={getInputProps("unit")}
        renderInput={(s) => 
          <InputText {...s}/> }

        //   <InputSelect
        //     {...s}
        //     options={props.teamList.map((o: any) => ({
        //       id: o.id,
        //       label: o.value,
        //       value: o.value,
        //     }))}
        //     value={selectedTeam?.value}
        //     onChange={onTeamChange}
        //     placeholder="* Chọn đội/tổ"
        //   />
        // )}
        isRequired
      />
      <InputWraper
        inputProps={getInputProps("nameVehical")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("licensePlate")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("vehicleRegistrationCertificate")}
        renderInput={(s) => <Upload {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("vehicleRegistrationCertificateId")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("certificateOfInspection")}
        renderInput={(s) => <Upload {...s} />}
        // isRequired
      />

      <InputWraper
        inputProps={getInputProps("certificateOfInspectionId")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("driveLicense")}
        renderInput={(s) => <UploadFile {...s} />}
      />

      <InputWraper
        inputProps={getInputProps("grantPeriod")}
        renderInput={(s) => (
          <InputDateRangePicker
            {...s}
            value={estimatedTimeOfUse}
            onChange={setEstimatedTimeOfUse}
            minDate={today}
          />
        )}
      />

      <InputWraper
        inputProps={getInputProps("grantedArea")}
        renderInput={(s) => <InputGroupSelect {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("gateAway")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("exit")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("photoContract")}
        renderInput={(s) => <UploadFile {...s} />}
      />

      <InputWraper
        inputProps={getInputProps("NumberOfVehicleLicensesIssued")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("OldKSANCardPhoto")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
// form dài hạn cấp lại
export const LongTermRenewExternalBusinessVehicleCardContentForm: FC<
  IInputArrayFormProps
> = (props:any) => {
  const { childFormData } = props;
  const today = new Date();
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(getDefaultEstimatedTimeOfUse(childFormData?.grantPeriod));

  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item:any) => {
      return {
        ...item,
        defaultValue:
          ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      // values.unit = selectedTeam ? selectedTeam.value : values.unit;
      values.grantPeriod = estimatedTimeOfUse ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1]) : values.grantPeriod;
      values.vehicleRegistrationCertificate = values.vehicleRegistrationCertificate.length > 0 ? JSON.stringify(values.vehicleRegistrationCertificate) : "";
      values.certificateOfInspection = values.certificateOfInspection.length > 0 ? JSON.stringify(values.certificateOfInspection) : "";
      values.ExcuseLose = values.ExcuseLose.length > 0 ? JSON.stringify(values.ExcuseLose) : "";
      // values.photoContract = values.photoContract.length > 0 && JSON.stringify(values.photoContract);

      // values.grantedArea = values.grantedArea.length > 0 && JSON.stringify(values.grantedArea);

      if (
        !values.nameVehical ||
        !values.licensePlate ||
        // !values.vehicleRegistrationCertificate ||
        !values.vehicleRegistrationCertificateId ||
        // !values.certificateOfInspection ||
        !values.grantedArea ||
        !values.gateAway ||
        !values.exit ||
        !values.unit ||
        // !values.OldKSANCardPhoto ||
        !values.NumberOfVehicleLicensesIssued ||
        !values.ExcuseLose

      )
      {CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return ;
      }
        
      else
        props.onSubmit(values);
    },
  });

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc
        phải nhập{" "}
      </h6>
      <InputWraper
        inputProps={getInputProps("unit")}
        renderInput={(s) => 
          <InputText {...s}/> }

        //   <InputSelect
        //     {...s}
        //     options={props.teamList.map((o: any) => ({
        //       id: o.id,
        //       label: o.value,
        //       value: o.value,
        //     }))}
        //     value={selectedTeam?.value}
        //     onChange={onTeamChange}
        //     placeholder="* Chọn đội/tổ"
        //   />
        // )}
        isRequired
      />
      <InputWraper
        inputProps={getInputProps("nameVehical")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("licensePlate")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("vehicleRegistrationCertificate")}
        renderInput={(s) => <Upload {...s} />}
        // isRequired
      />

      <InputWraper
        inputProps={getInputProps("vehicleRegistrationCertificateId")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("certificateOfInspection")}
        renderInput={(s) => <Upload {...s} />}
        // isRequired
      />

      <InputWraper
        inputProps={getInputProps("certificateOfInspectionId")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("driveLicense")}
        renderInput={(s) => <UploadFile {...s} />}
      />

      <InputWraper
        inputProps={getInputProps("grantPeriod")}
        renderInput={(s) => (
          <InputDateRangePicker
            {...s}
            value={estimatedTimeOfUse}
            onChange={setEstimatedTimeOfUse}
            minDate={today}
          />
        )}
      />

      <InputWraper
        inputProps={getInputProps("grantedArea")}
        renderInput={(s) => <InputGroupSelect {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("gateAway")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("exit")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("NumberOfVehicleLicensesIssued")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("photoContract")}
        renderInput={(s) => <UploadFile {...s} />}
      />

      <InputWraper
        inputProps={getInputProps("OldKSANCardPhoto")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />

      <InputWraper
        inputProps={getInputProps("ExcuseLose")}
        renderInput={(s) => <Upload {...s} />}
        isRequired
      />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
